import React from "react";
import ErrorIcon from "../../assets/icons/ErrorIcon";
import styles from "./NotFound.module.scss";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className={styles.notFoundPage}>
      <ErrorIcon />
      <div className={styles.content}>
        <h2 className={styles.title}>This page doesn't exist</h2>
        <p className={styles.text}>The page you're looking for doesn't exist</p>
      </div>
      <Link to={"/main/account"} className={styles.notFoundButton}>
        Back
      </Link>
    </div>
  );
};

export default NotFound;
